import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'

import { URL } from '../../const'
import { fetchPush } from '../../actions'
import Loader from '../_common/Loader'
import Modal from '../_common/Modal'
import PushStats from './PushStats'

class PushNotifications extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showPushStats: false,
      pushID: null,
      pushStats: null,
      statsLoading: true
    }
  }

  componentDidMount () {
    // Fetch push list
    this.props.fetchPush()
  }
  _handleSendClick (id, e) {
    e.stopPropagation()
    console.log('sending push notification, ', id)
  }
  _handlePushClick (data) {
    this.props.history.push({
      pathname: `/push/edit/${data.id}`,
      state: { data }
    })
  }
  _handlePushStatsClick (id, e) {
    e.stopPropagation()
    this.setState({ showPushStats: true, pushID: id, statsLoading: true })
    this._fetchPushStatus(id)
  }
  _closeModal = () => {
    this.setState({ showPushStats: false, pushID: null, pushStats: null })
  }

  async _fetchPushStatus (id) {
    try {
      const url = `${URL}push_status/${id}`
      const config = {
        headers: {
          'Authorization': `Token ${this.props.user.token}`
        }
      }

      const res = await axios.get(url, config)
      if (res.data && res.data.residents) {
        this.setState({ pushStats: res.data.residents, statsLoading: false })
      }
    } catch (error) {
      console.log('an error occured: ', error)
    }
  }

  _renderNotificationButton (id, status) {
    switch (Number(status)) {
      case 0: // sent
        return <button className="btn sent" disabled>配信済</button>
      case 1: // timer_set
        return <button className="btn timer_set" disabled>配信予約済</button>
      default:
        return <button className="btn primary" onClick={ (e) => this._handleSendClick(id, e) }>配信する</button>
    }
  }

  _renderNotifications () {
    if (this.props.push && !this.props.push.loading) {
      const data = this.props.push.data
      const sortedData = [...data]
      sortedData.sort(function (a, b) {
        const dateA = moment(a.created, 'YYYY/MM/DD HH:mm')
        const dateB = moment(b.created, 'YYYY/MM/DD HH:mm')
        if (dateA > dateB) {
          return -1
        } else {
          return 1
        }
      })
      return sortedData.map(item => {
        return (
          <li key={item.id} className="flex align-center" onClick={ () => this._handlePushClick(item) }>
            <div className="notification_date flex column">
              <span>{ item.updated }更新</span>
              <span>{ item.created }作成</span>
            </div>
            <div className="notification_title bold medium">{ item.title }</div>
            <div className="button_container column">
              <div className="btn reverse_red flex column" onClick={ (e) => this._handlePushStatsClick(item.id, e) }>
                <span>配信数：{item.sent_number}</span>
                <span>開封数：{item.opened_number}</span>
              </div>
              { this._renderNotificationButton(item.id, item.status) }
            </div>
          </li>
        )
      })
    }
    return <Loader classname="loader_dot_circle"/>
  }
  _renderModal () {
    if (this.state.showPushStats) {
      return (
        <Modal
          title="Push通知データー"
          closeModal={this._closeModal}
          noBtn
        >
          <PushStats pushStats={this.state.pushStats} loading={this.state.statsLoading}/>
        </Modal>
      )
    }
    return null
  }

  render () {
    return (
      <section className="push_notification">
        { this._renderModal() }
        <h4 className="page_title bold">Push通知</h4>
        <div className="flex add_notification justify-between align-center">
          <Link to={`/push/add`} className="btn primary small_btn">新規作成</Link>
          <span className="bold">{this.props.push.data ? this.props.push.data.length : '0'}件</span>
        </div>
        <ul>
          { this._renderNotifications() }
        </ul>
      </section>
    )
  }
}

function mapStateToProps ({ user, push }) {
  return { user, push }
}

export default connect(mapStateToProps, { fetchPush })(PushNotifications)



// WEBPACK FOOTER //
// ./src/components/PushNotifications/index.js